import { rtkapi } from "./rtkapi"

const systemapi = rtkapi.enhanceEndpoints({addTagTypes: ["System"]}).injectEndpoints({
    endpoints: (build) => ({
        getSystems: build.query({
            query: (params=null) => ({ url: '/lexicon/systems/', method: 'get', params:params}),
            providesTags:['System']
        }),

        createSystem: build.mutation({
            query: (data) => ({url: '/lexicon/systems/', method:'post', data:data}),
            invalidatesTags:['System', 'Serie']

        }),

        updateSystem: build.mutation({
            query: ({id,data}) => ({url: `/lexicon/systems/${id}/`, method:'patch', data:data}),
            invalidatesTags:['System', 'Serie']

        }), 

        batchImport: build.mutation({
            query: (data) => ({url: `/lexicon/batch-import-systems/`, method:'post', data:data}),
            invalidatesTags:['System', 'Serie']
        }), 

        updatePart: build.mutation({
            query: (data) => ({url: `/lexicon/update-parts/`, method:'patch', data:data}),
            invalidatesTags:['System', 'Serie']
        }),
        
    })
})

export const { useGetSystemsQuery, useCreateSystemMutation, useUpdateSystemMutation, useBatchImportMutation, useUpdatePartMutation } = systemapi;
